export default "__VITE_PUBLIC_ASSET__a12f17aa__"